import React, { createContext, useContext, ReactNode, useRef } from "react";

interface IntersectionObserverContext {
  container: React.RefObject<Element | null>;
}

const ContainerContext = createContext<IntersectionObserverContext | undefined>(
  undefined
);

interface IntersectionObserverProps {
  children: ReactNode;
}

export const IntersectionObserverProvider: React.FC<
  IntersectionObserverProps
> = ({ children }) => {
  const container = useRef<Element | null>(null);

  return (
    <ContainerContext.Provider value={{ container }}>
      {children}
    </ContainerContext.Provider>
  );
};

export const useIntersectionObserver = (): IntersectionObserverContext => {
  const context = useContext(ContainerContext);
  if (!context) {
    throw new Error(
      "useIntersectionObserver must be used within a IntersectionObserverProvider"
    );
  }
  return context;
};
